import { t } from "i18next";
import { useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../context/ThemeContext";
import OutsideClickHandler from "react-outside-click-handler";
const ForgotPassword = () => {
  const [tab, setTab] = useState("email");
  const navigate = useNavigate();
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });

  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />{" "}
        <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page__main popup-page-main popup-page-main--show"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__header"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__title"
              >
                {t("ForgotPassword")}
              </div>
              <div
                onClick={() => navigate("/")}
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__close ng-star-inserted"
              />
            </div>
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__container"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="content register-content"
              >
                <router-outlet _ngcontent-serverapp-c2790459173 name="popup" />
                <ng-component className="ng-star-inserted">
                  <router-outlet />
                  <ng-component
                    _nghost-serverapp-c613070388
                    className="ng-tns-c613070388-38 ng-star-inserted"
                  >
                    <app-tab-button-nav
                      _ngcontent-serverapp-c613070388
                      className="ng-tns-c613070388-38"
                      _nghost-serverapp-c1328719065
                    >
                      <div
                        _ngcontent-serverapp-c1328719065
                        className="tab-btn tab-btn-page"
                      >
                        <div
                          _ngcontent-serverapp-c1328719065
                          className="line"
                          style={{
                            width: "calc(50%)",
                            "-webkit-transform": "translate(0%, 0px)",
                            "-ms-transform": "translate(0%, 0px)",
                            transform:
                              tab == "email"
                                ? "translate(0%, 0px)"
                                : "translate(100%, 0px)",
                          }}
                        />
                        <div
                          onClick={() => setTab("email")}
                          _ngcontent-serverapp-c1328719065
                          drctablinkactive="active"
                          className={`btn ng-star-inserted ${
                            tab == "email" ? "active" : ""
                          }`}
                          data-tab-current={tab == "email" ? "current" : ""}
                        >
                          <div
                            _ngcontent-serverapp-c1328719065
                            className="text"
                          >
                            {t("Email")}
                          </div>
                        </div>
                        <div
                          onClick={() => setTab("sms")}
                          _ngcontent-serverapp-c1328719065
                          drctablinkactive="active"
                          className={`btn ng-star-inserted ${
                            tab == "sms" ? "active" : ""
                          }`}
                          data-tab-current={tab == "sms" ? "current" : ""}
                        >
                          <div
                            _ngcontent-serverapp-c1328719065
                            className="text"
                          >
                            {t("SMS")}
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c1328719065
                        className="tab-btn-page-underline"
                      />
                    </app-tab-button-nav>
                    <div
                      _ngcontent-serverapp-c613070388
                      className="ng-tns-c613070388-38 ng-trigger ng-trigger-tabPageTriggerAni"
                    >
                      <router-outlet
                        _ngcontent-serverapp-c613070388
                        className="ng-tns-c613070388-38"
                      />
                      <ng-component
                        _nghost-serverapp-c1738099249
                        className="ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c1738099249
                          className="tab-content tab-content-page forgetpassword ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c1738099249
                            className="logo-box data-image"
                            style={{
                              backgroundImage:
                                theme == "light"
                                  ? `url("/assets/Other/logo-light.png")`
                                  : `url("/assets/Other/logo.png")`,
                            }}
                          />
                          <form
                            _ngcontent-serverapp-c1738099249
                            noValidate
                            className="inner-wrap ng-untouched ng-pristine ng-invalid"
                          >
                            <div
                              _ngcontent-serverapp-c1738099249
                              className="inner-box"
                            >
                              <div style={{background:'transparent'}}
                                _ngcontent-serverapp-c1738099249
                                className="menu-box"
                              >
                                <div
                                  _ngcontent-serverapp-c1738099249
                                  className="input-group"
                                >
                                  <label _ngcontent-serverapp-c1738099249>
                                    {t("Username")}
                                  </label>
                                  <input
                                    _ngcontent-serverapp-c1738099249
                                    type="text"
                                    removewhitespace
                                    className="input ng-untouched ng-pristine ng-invalid"
                                    placeholder={t("Username")}
                                  />
                                  <input
                                    _ngcontent-serverapp-c1738099249
                                    className="clear"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c1738099249
                                  className="input-group"
                                >
                                  <label _ngcontent-serverapp-c1738099249>
                                    {t("Email")}
                                  </label>
                                  <input
                                    _ngcontent-serverapp-c1738099249
                                    type="text"
                                    className="input ng-untouched ng-pristine ng-invalid"
                                    placeholder={t("InputValidEmail")}
                                  />
                                  <input
                                    _ngcontent-serverapp-c1738099249
                                    className="clear"
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-serverapp-c1738099249
                                className="button btn-primary"
                              >
                                <a _ngcontent-serverapp-c1738099249>
                                  {t("Confirm")}
                                </a>
                              </div>
                            </div>
                          </form>
                        </div>
                      </ng-component>
                    </div>
                  </ng-component>
                </ng-component>
              </div>
            </div>
          </div>{" "}
        </OutsideClickHandler>
      </div>
    </app-popup-page>,
    document.getElementById("overlay"),
  );
};

export default ForgotPassword;
